import { call, put, takeLeading } from 'redux-saga/effects';
import { parametersActions } from '../reducers/parameter';
import parametersGateway from '../api/parameter';

function* parametersDataRequest({ payload }: any): any {
  const res = yield call(parametersGateway.fetchParameters, payload);
  if (res.status === 'success') {
    yield put(parametersActions.getParametersDataResponse(res));
  } else {
    yield put(parametersActions.getParametersDataFailed());
  }
}

function* parametersSaga() {
  yield takeLeading('parameters/getParametersDataRequest', parametersDataRequest);
}

export default parametersSaga;
